
import { Component, Vue, Prop, Model, Emit } from "vue-property-decorator";

@Component({})
export default class TradeComponent extends Vue {
  name = "trade";
}
